import Axios from 'axios';
import header from './auth/header';

const API_URL =  process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3/';

class SumberDana {
  indexV3(){
    return Axios.get(API_URL_V3 + 'data/fund-sources', { headers: header() });
  }
  index() {
    return Axios.get(API_URL + 'sumberdana-list');
  }

  show(sumberdana) {
    return Axios.get(API_URL + `sumberdana/${sumberdana}`);
  }
}

export default new SumberDana();



// WEBPACK FOOTER //
// ./src/api/sumberdana.js